export default "<button [id]=\"id\" class=\"tnd-btn\" [class]=\"extraClass\" (click)=\"onTap ? onTap : ''\">\n  <ng-content>\n    \n  </ng-content>\n</button>";